export function mpe_records_do_exists(response) {
  if (response?.opportunity?.mpeRecordExists === null) {
    return "none";
  } else {
    return response.opportunity.mpeRecordExists;
  }
}
